const stackdata = [
  {
    name: "react",
    slug: "react",
    icon: "fab fa-react",
  },
  {
    name: "vue",
    slug: "vue",
    icon: "fab fa-vuejs",
  },
  {
    name: "java",
    slug: "java",
    icon: "fab fa-java",
  },
  {
    name: "frontend",
    slug: "frontend",
    icon: "fas fa-code",
  },
  {
    name: "backend",
    slug: "backend",
    icon: "fas fa-cogs",
  },
  {
    name: "php",
    slug: "php",
    icon: "fab fa-php",
  },
  {
    name: "python",
    slug: "python",
    icon: "fab fa-python",
  },
  {
    name: "Go",
    slug: "go",
    icon: "fas fa-ring",
  },
  {
    name: "angular",
    slug: "angular",
    icon: "fab fa-angular",
  },
  {
    name: "mobile",
    slug: "mobile",
    icon: "fas fa-mobile-alt",
  },
  {
    name: "javascript",
    slug: "javascript",
    icon: "fab fa-js",
  },
  {
    name: "nodejs",
    slug: "node",
    icon: "fab fa-node",
  },
  {
    name: "laravel",
    slug: "laravel",
    icon: "fab fa-laravel",
  },
  {
    name: "css3",
    slug: "css",
    icon: "fab fa-css3-alt",
  },
  {
    name: ".net",
    slug: "dotnet",
    icon: "fab fa-neos",
  },
  {
    name: "html5",
    slug: "html",
    icon: "fab fa-html5",
  },
  {
    name: "ruby",
    slug: "ruby",
    icon: "fas fa-gem",
  },
  {
    name: "c",
    slug: "c",
    icon: "fab fa-cuttlefish",
  },
];

export default stackdata;